import {NgModule} from '@angular/core';
import {AuthRoutingModule} from './auth-routing.module';
import {LoginModule} from './login/login.module';

@NgModule({
  imports: [LoginModule, AuthRoutingModule],
})
export class AuthModule {}
